<template>
  <article class="queue-up-display-page text-left">
    <v-row justify="center">
      <v-col cols="12"
             sm="12"
             md="4">
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="6">
            <p>
              {{ QUEUE_UP_DISPLAY_DATA.operateText}}
            </p>
            <ul>
              <li v-for="(operate, i) in QUEUE_UP_DISPLAY_DATA.operate"
                :key="i"
              >
                {{operate}}
              </li>
            </ul>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="6">
            <p>
              {{ QUEUE_UP_DISPLAY_DATA.prepareText}}
            </p>
            <ul>
              <li v-for="(prepare, i) in QUEUE_UP_DISPLAY_DATA.prepare"
                  :key="i"
              >
                {{prepare}}
              </li>
            </ul>
          </v-col>

        </v-row>
        <p v-html="QUEUE_UP_DISPLAY_DATA.message"/>
      </v-col>
    </v-row>
  </article>
</template>

<script>
import {mapGetters} from "vuex";


export default {
  name: "Queue-Up-Scan-Page",
  beforeCreate() {
    this.$store.dispatch('GET_QUEUE_UP_DISPLAY_DATA', {
      tenantCode: this.$route.params.tenantCode,
      code: this.$route.params.code
    });
  },
  mounted: function () {
    window.setInterval(() => {

      if (this.$route.name !== 'Scan') {
        return;
      }

      this.$store.dispatch('GET_QUEUE_UP_DISPLAY_DATA', {
        tenantCode: this.$route.params.tenantCode,
        code: this.$route.params.code
      });
    }, 10000);
  },
  computed: {
    ...mapGetters([
      'QUEUE_UP_DISPLAY_DATA',
    ])
  },
  methods: {
    goToConfirmPage() {
      this.$router.push({
        path: this.QUEUE_UP_SCAN_DATA.url.replace("https://tools.quasiris.de", " ").trim()
      });
    }
  }
}
</script>
